import React from "react";
import { Route } from "react-router-dom";

import { View } from "../../../components";
import { applet, views } from "./core";

// import RegisterView from './RegisterView';
const RegisterView = React.lazy(() => import("./RegisterView"));

export default [
  [views.suaformatura, RegisterView],
  [views.parceiras, RegisterView],
].map(([view, component]) => (
  <Route exact key={view} path={view}>
    <View view={view} applet={applet} component={component} />
  </Route>
));
